module.exports = __webpack_public_path__ + "static/img/10.81908bc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/eng/10.png
// module id = XuH5
// module chunks = 0